// test1506
(1506 && 0);
